import React from "react";

export function renderContentWithLineBreaks(content: string | undefined) {
    if (typeof content !== "string") content = "";

    // Split on <br> and <b>...</b> and treat both as block-level breaks
    const splitWithBoldAndBreaks = (text: string) => {
        // Split on <b>...</b>
        const parts = text.split(/(<b>.*?<\/b>)/gi);
        return parts.map((part, i) => {
            const boldMatch = part.match(/^<b>(.*?)<\/b>$/i);
            if (boldMatch) {
                return (
                    <React.Fragment key={i}>
                        <b>{boldMatch[1]}</b>
                        <span className="block py-0.5" />
                    </React.Fragment>
                );
            }
            return part;
        });
    };

    // Split on <br> and treat as block-level breaks
    return content.split(/<br\s*\/?>/i).map((part, idx, arr) =>
        idx < arr.length - 1
            ? (
                <React.Fragment key={idx}>
                    {splitWithBoldAndBreaks(part)}
                    <br />
                    <span className="block py-0.5" />
                </React.Fragment>
            )
            : splitWithBoldAndBreaks(part)
    );
}